import { ref } from '@vue/composition-api';
import { defineStore } from 'pinia';

export const useWidgetStore = defineStore('widget', () => {
  const averageDealCloseDays = ref(null);
  const wonValue = ref(0);

  const setAverageDealCloseDays = (days: number) => {
    averageDealCloseDays.value = days;
  };

  const setWonValue = (value: number) => {
    wonValue.value = value;
  };

  return {
    setAverageDealCloseDays,
    setWonValue,
    averageDealCloseDays,
    wonValue,
  };
});
